const OutcomeLabelHead = {
    title: 'Example JSON',
    expectedOutput: 'Arsenal (participant1 - participant2)',
    initialDisplayedCode: `{
      "outcomeId": 2950948551,
      "betOffer": {
        "id": 883929922,
        "betOfferType": {
          "id": 13,
          "name": "betOffer name"
        }`,
    moreCode: `,
    "place": false,
        "outcomes": [
          {
            "id": 2950948551,
            "label": "Arsenal",
            "participant": "participant1",
            "type": "OT_ONE_CROSS"
          },
          {
            "id": 2950948554,
            "label": "Feyenoord",
            "participant": "participant2",
            "type": "OT_ONE_TWO"
          }
        ]
    },
    "event": {
      "awayName": "EventAwayName",
      "homeName": "EventHomeName"
    }
}`,
};

export default OutcomeLabelHead;
